import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Startup from "./pages/Startup";
import Blog from "./pages/Blog";
import Support from "./pages/Support";
import Pricing from "./pages/Pricing";
import Features from "./pages/Features";
import AskSeoChan from "./pages/AskSeoChan";
import Privacy from "./pages/Privacy";
import ChangeLog from "./pages/ChangeLog";
import Glossary from "./pages/Glossary";
import MostVisited from "./pages/MostVisited";
import Terms from "./pages/Terms";
import BlogPost from "./pages/BlogPost";
import BlogShort from "./pages/BlogShort";
import SupportPost from "./pages/SupportPost";
import RobotsTxtTester from "./pages/RobotsTxtTester";
import KeywordDensityChecker from "./pages/KeywordDensityChecker";
import LLMSTxtGenerator from "./pages/LLMSTxtGenerator";
import WebAudit from "./pages/WebAudit";
import NotFound from "./pages/404";
import { HelmetProvider } from 'react-helmet-async';
import EasyToUse from "./pages/EasyToUse";
import AIDetector from "./pages/AIDetector";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/startup" element={<Startup />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/help" element={<Support />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/features" element={<Features />} />
          <Route path="/easy-to-use" element={<EasyToUse />} />
          <Route path="/ask-seochan" element={<AskSeoChan />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/changelog" element={<ChangeLog />} />
          <Route path="/glossary" element={<Glossary />} />
          <Route path="/most-visited" element={<MostVisited />} />
          <Route path="/blog/:parama" element={<BlogPost />} />
          <Route path="/a/:short" element={<BlogShort />} />
          <Route path="/help/:parama" element={<SupportPost />} />
          <Route path="/robots-txt-tester" element={<RobotsTxtTester />} />
          <Route path="/kw-density-checker" element={<KeywordDensityChecker />} />
          <Route path="/llms-txt-generator" element={<LLMSTxtGenerator />} />
          <Route path="/webaudit" element={<WebAudit />} />
          <Route path="/aidetector" element={<AIDetector />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}


export default App;
